import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=03835124&scoped=true"
import script from "./Sobre.vue?vue&type=script&lang=js"
export * from "./Sobre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03835124",
  null
  
)

export default component.exports